<template>
  <div>
    <transition-group name="fade" tag="div">
      <div v-for="i in [currentIndex]" :key="i" class="wrap-img">
        <img :src="currentImg" id="img" />
      </div>
    </transition-group>
    <div class="text-center d-block my-3">
      <button type="button" class="btn-rotate" @click="rotateImgMinus"><b-icon icon="arrow-counterclockwise" aria-hidden="true" scale="2"></b-icon></button>
      <button type="button" class="btn-rotate" @click="rotateImgPlus"><b-icon icon="arrow-clockwise" aria-hidden="true" scale="2"></b-icon></button>
      <button type="button" class="btn-rotate" @click="zoomIn"><b-icon icon="plus" scale="3"></b-icon></button>
      <button type="button" class="btn-rotate" @click="zoomOut"><b-icon icon="dash" scale="3"></b-icon></button>
    </div>
    <a class="prev" @click="prev" href="#">&#10094; Previous</a>
    <a class="next" @click="next" href="#"> Next &#10095;</a>
  </div>
</template>

<script>
export default {
  name: "Slider",
  data() {
    return {
      images: [],
      timer: null,
      currentIndex: 0,
      deg: 0,
      scale: 1,
    };
  },
  props: {
    attachment: Object,
  },

  mounted: function() {
    this.images.push(
      this.attachment.photo,
      this.attachment.photo_with_ktp,
      this.attachment.signature,
      this.attachment.npwp,
      this.attachment.ktp,
      this.attachment.kk
      // this.attachment.other
    );
  },

  methods: {
    startSlide: function() {
      this.timer = setInterval(this.next, 4000);
    },

    rotateImgMinus() {
      let img = document.getElementById("img");
      this.deg -= 90;

      img.style.transform = "rotate(" + this.deg + "deg)";
      img.style.transformOrigin = "center";
    },
    rotateImgPlus() {
      let img = document.getElementById("img");
      this.deg += 90;

      img.style.transform = "rotate(" + this.deg + "deg)";
      img.style.transformOrigin = "center";
    },

    zoomIn() {
      let img = document.getElementById("img");
      this.scale += 0.5;

      img.style.transform = "scale(" + this.scale + ")";
      img.style.transformOrigin = "left";
    },
    zoomOut() {
      let img = document.getElementById("img");
      this.scale -= 0.5;
      if (this.scale < 1) {
        return;
      }
      img.style.transform = "scale(" + this.scale + ")";
      img.style.transformOrigin = "left";
    },
    next: function() {
      this.currentIndex += 1;
    },
    prev: function() {
      this.currentIndex -= 1;
    },
  },

  computed: {
    currentImg: function() {
      return this.images[Math.abs(this.currentIndex) % this.images.length];
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width: 100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width: 100%;
  opacity: 0;
}

.wrap-img {
  text-align: center;
  min-height: 500px;
  width: 100%;
  overflow: auto;
}

/* img {
  height: 500px;
  width: 100%;
} */

.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 40%;
  width: auto;
  padding: 16px;
  color: var(--primary);
  font-weight: bold;
  font-size: 18px;
  transition: 0.7s ease;
  border-radius: 0 4px 4px 0;
  text-decoration: none;
  user-select: none;
}

.next {
  right: 0;
}

.prev {
  left: 0;
}

.prev:hover,
.next:hover {
  background-color: var(--primary);
  color: #fff;
}

.btn-rotate {
  border: none;
  margin: 0.5rem;
  background: transparent;
}

.btn-rotate:focus {
  outline: none;
}
</style>
